export class BooleanUtils {
  public static booleanComparator(valueA: boolean, valueB: boolean): number {
    const comparison = valueA > valueB ? 1 : -1;
    return valueA === valueB ? 0 : comparison;
  }
}
